document.addEventListener("DOMContentLoaded", function () {
  let collectionFeaturedProducts = new Swiper(".cataloge", {
      pagination: {
          el: ".cataloge .swiper-pagination",
          clickable: true,
      },
      navigation: {
          nextEl: ".cataloge .swiper-button-next",
          prevEl: ".cataloge .swiper-button-prev",
      },
      loop: false,
      centeredSlides: false,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 10,
      autoHeight: false,
      breakpoints: {
          749: {
              slidesPerView: 5,
              slidesPerGroup: 5
          },
          1024: {
              slidesPerView: 5,
              slidesPerGroup: 5
          }
      }
  });

  document.querySelector(".swiper-button-next-custom").addEventListener("click", function () {
      collectionFeaturedProducts.slideNext();
  });

  document.querySelector(".swiper-button-prev-custom").addEventListener("click", function () {
      collectionFeaturedProducts.slidePrev();
  });

});


/* BLOCK - STORIES */

const featuredProductAdvancedStories = document.querySelector('.product-information__stories');

if(featuredProductAdvancedStories) {

    const swiperStories = new Swiper(".stories-modal .swiper", {
        effect: 'cube',
        observer: true,
        observeParents: true,
        pagination: {
            el: ".stories-modal .swiper-pagination",
            type: "progressbar",
        },
        navigation: {
            nextEl: ".stories-modal .swiper-button-next",
            prevEl: ".stories-modal .swiper-button-prev",
        },
    });

    window.addEventListener('load', () => {
        swiperStories.update();
    });

    /* STORIES */

    const stories = document.querySelector('.stories');
    const storiesStory = stories.querySelectorAll('.story');
    const replayButtons = document.querySelectorAll('.story__button.replay');
    const storiesModal = document.querySelector('.stories-modal');
    const storiesModalWrapper = storiesModal.querySelector('.swiper .swiper-wrapper');
    const storiesModalStory = storiesModal.querySelectorAll('.story');

    function openStoriesModal(){
    storiesModal.setAttribute('open', '');
    }

    function closeStoriesModal(){
    storiesModal.removeAttribute('open');
    }

    /* RELOAD */

    replayButtons.forEach(button => {
    button.addEventListener('click', () => {

        const storySlide = button.closest('.swiper-slide');
        const video = storySlide.querySelector('.video video');
        
        if (video) {
            video.pause();
            video.currentTime = 0;
            video.play();

            const playPauseButton = storySlide.querySelector('.story__button#playback');
            
            if (playPauseButton) {
                playPauseButton.dataset.state = 'break';
            }
        }
    });
    });

    function updateStorieModalStory(storyId){

        for(let i=0;i<storiesModalStory.length;i++){
                
            const storyVideo = storiesModalStory[i].querySelector('.video video');
            storyVideo.pause();
            storyVideo.currentTime = 0;

            // BUTTONS
            const storyButtons = storiesModalStory[i].querySelectorAll('.story__contols .story__button');
            for(let j=0;j<storyButtons.length;j++){
                if(storyButtons[j].id == 'playback'){
                storyButtons[j].dataset.state = 'break';
                }
            }

        }

        if(storyId != null){
            const storyVideo = storiesModalStory[storyId-1].querySelector('.video video');
            storyVideo.play();
        }

    }

    /* MODAL */

    storiesModalStory.forEach((story, index) => {

        const progressBar = story.querySelector('.progress-container .progress-bar');
        const storyVideo = story.querySelector('.video video');
        storyVideo.id = index;

        // VIDEO
        storyVideo.addEventListener('timeupdate', () => {
            const percentage = (storyVideo.currentTime / storyVideo.duration) * 100;
            progressBar.style.width = percentage + '%';
        });

        //BUTTONS
        const storyButtons = story.querySelectorAll('.story__contols .story__button');

        storyButtons.forEach(button => {

            button.addEventListener('click', () => {

                if(button.id == 'close'){
                    closeStoriesModal();
                    updateStorieModalStory(null);
                }else if(button.id == 'sound'){
                    if(button.dataset.state == 'off'){
                        storyVideo.muted = false;
                        button.dataset.state = 'on';
                    }else if(button.dataset.state == 'on'){
                        storyVideo.muted = true;
                        button.dataset.state = 'off';
                    }
                }else if(button.id == 'playback'){
                    if(button.dataset.state == 'break'){
                        storyVideo.pause();
                        button.dataset.state = 'play';
                    }else if(button.dataset.state == 'play'){
                        storyVideo.play();
                        button.dataset.state = 'break';
                    }
                }
            })

        })

    })

    /* STORY */

    storiesStory.forEach(story => {
        story.addEventListener('click', () => {

            openStoriesModal();

            const storyId = story.id;
            swiperStories.slideTo(storyId-1);

            const currentStorySlide = storiesModalStory[storyId-1];
            const replayButton = currentStorySlide.querySelector('.story__button.replay');

            if (replayButton) {
                replayButton.click();
            }

        })
    })

    /* SLIDE CHANGE */

    swiperStories.on('slideChange', () => {
        updateStorieModalStory(swiperStories.activeIndex+1);
    });

}


/* BLOCK - ACCORDION TAB */

const featuredProductAdvancedAccorions = document.querySelector('.featured-product-advanced__accordion-tab');

if(featuredProductAdvancedAccorions) {

    const featuredProductAdvancedAccorionsTabs = document.querySelectorAll('.featured-product-advanced__accordion-tab .item');

    featuredProductAdvancedAccorionsTabs.forEach((tab, index) =>{
        if(index == 1){
            tab.style.visibility = "hidden";
            tab.style.position = "absolute";
        }
    })

    featuredProductAdvancedAccorionsTabs.forEach(item =>{

        const itemTitle = item.querySelector('.item__title');

        itemTitle.addEventListener('click', () =>{

            // CLOSE ALL TABS
            for(let i=0;i<featuredProductAdvancedAccorionsTabs.length;i++){
                const tabTitle = featuredProductAdvancedAccorionsTabs[i].querySelector('.item__title');
                if(tabTitle != itemTitle) {
                    const tab = featuredProductAdvancedAccorionsTabs[i];
                    tab.style.height = `40px`
                    tab.classList.remove('open');
                }
            }

            // OPEN CLICKED TAB
            const itemContent = item.querySelector('.item__content');

            if(item.classList.contains('open')){
                item.style.height = `40px`
                item.classList.remove('open');
            }else{
                item.style.height = `${itemContent.offsetHeight+40}px`
                item.classList.add('open');
            }

        })
        
    })

}